import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Page } from "@/components/SiteLayout";

const Review = () => (
  <p className="mt-4 rounded-xl border border-dashed border-[#b85d3b] bg-[#fbf1ea] p-4 text-sm text-[#8a3f22]" data-testid="legal-review-banner">
    TEXTO INICIAL — PENDENTE DE REVISÃO JURÍDICA antes da comercialização.
  </p>
);

const Legal = ({ title, sections, children }) => (
  <Page>
    <article className="mx-auto max-w-2xl px-5 py-10">
      <h1 className="text-3xl text-stone-900 sm:text-4xl">{title}</h1>
      <Review />
      {sections.map(([h, t]) => (
        <section key={h} className="mt-8">
          <h2 className="text-lg text-stone-900">{h}</h2>
          <p className="mt-2 leading-relaxed text-stone-700">{t}</p>
        </section>
      ))}
      {children}
    </article>
  </Page>
);

const DeletionForm = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [msg, setMsg] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      const r = await api.post("/privacy/deletion-request", { email, message });
      setMsg(r.data.message);
    } catch (err) {
      setMsg(errMsg(err));
    }
  };
  return (
    <form onSubmit={submit} className="mt-10 rounded-2xl border bg-white p-6" data-testid="deletion-form">
      <h2 className="text-lg text-stone-900">Solicitar exclusão dos meus dados</h2>
      <input required type="email" className="field mt-4" placeholder="E-mail usado no Mapa" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="deletion-email-input" />
      <textarea className="field mt-3 min-h-[90px] py-3" placeholder="Observações (opcional)" value={message} onChange={(e) => setMessage(e.target.value)} data-testid="deletion-message-input" />
      <button className="btn-primary mt-4 w-full" data-testid="deletion-submit-button">Enviar solicitação</button>
      {msg && <p className="mt-4 text-sm text-stone-700" data-testid="deletion-result">{msg}</p>}
    </form>
  );
};

export const Privacy = () => (
  <Legal title="Política de privacidade" sections={[
    ["Quem somos", "Escola da Virada 360°, responsável pelo produto Seu Mapa da Virada 360°. [Razão social e dados do controlador a preencher]"],
    ["Dados coletados", "Dados da compra recebidos da Kiwify (nome, e-mail e identificador do pedido), dados do cadastro (nome, e-mail, WhatsApp, faixa etária opcional, nome e características do negócio) e as respostas ao questionário. Não coletamos CPF, CNPJ numérico, endereço ou dados financeiros detalhados."],
    ["Finalidade", "Liberar o acesso adquirido, gerar e armazenar seu relatório individual e permitir contato da Escola sobre o Mapa e seus próximos passos."],
    ["Inteligência artificial", "A redação do relatório é feita por um provedor de inteligência artificial, que recebe suas respostas organizadas apenas para essa finalidade."],
    ["Compartilhamento", "Não vendemos seus dados. Eles são tratados por fornecedores necessários à operação (pagamento, hospedagem, e-mail e IA)."],
    ["Seus direitos", "Você pode solicitar acesso, correção ou exclusão dos seus dados a qualquer momento pelo formulário abaixo ou pelo contato informado no rodapé."],
  ]}>
    <DeletionForm />
  </Legal>
);

export const Terms = () => (
  <Legal title="Termos de uso" sections={[
    ["O produto", "Seu Mapa da Virada 360° é uma experiência digital de reflexão para empreendedores, com relatório individual gerado a partir das respostas fornecidas."],
    ["O que o Mapa não é", "Não é consultoria completa, avaliação psicológica, diagnóstico científico de personalidade nem garantia de resultados financeiros."],
    ["Acesso", "O acesso é individual e liberado após a confirmação do pagamento pela Kiwify. O link é pessoal e não deve ser compartilhado."],
    ["Pagamento e reembolso", "Pagamento processado externamente pela Kiwify, conforme as condições exibidas no checkout. [Política de reembolso a definir]"],
    ["Responsabilidade", "As decisões tomadas a partir do relatório são de responsabilidade do empreendedor."],
  ]} />
);
